import {
  type AnchorHTMLAttributes,
  type ComponentType,
  createContext,
  type ReactNode,
  useContext,
} from "react";

export type UiLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
  children?: ReactNode;
};

function PlainLink({ href, children, ...rest }: UiLinkProps) {
  return (
    <a href={href} {...rest}>
      {children}
    </a>
  );
}

const LinkContext = createContext<ComponentType<UiLinkProps>>(PlainLink);

// Components that navigate render through this, so the app can plug in its router's Link.
export function LinkProvider({
  component,
  children,
}: {
  component: ComponentType<UiLinkProps>;
  children: ReactNode;
}) {
  return <LinkContext.Provider value={component}>{children}</LinkContext.Provider>;
}

export function UiLink(props: UiLinkProps) {
  const Component = useContext(LinkContext);
  return <Component {...props} />;
}
